/**
 * モーダル関連
 */

import $ from 'jquery';
import { TweenMax } from 'gsap';
import { loginCheck, loginAuth, loginForgot, logout } from './login';
import { trigger } from './utility';
import { mq } from './Global';
const tm = TweenMax;

export default class Modal {
	constructor() {
		this.root = document.querySelector('#modal');
		this.container = this.root.querySelectorAll('.modal-container');
		this.portal = this.root.querySelector('.modal-container--portal');
		this.signin = this.root.querySelector('.modal-container--signin');
		this.forgot = this.root.querySelector('.modal-container--forgot');
		this.method = this.root.querySelector('.modal-container--method');
		this.degradation = this.root.querySelector('.modal-container--degradation');
		this.inr = document.querySelectorAll('.modal-container__inr');
		this.open_btn = document.querySelectorAll('.modal-open');
		this.close_area = this.root.querySelector('.modal-close');
		this.close_btn = document.querySelectorAll('.modal-close');
		this.move_btn = this.root.querySelectorAll('.modal-move');
		this.submit_btn = this.root.querySelectorAll('.submit-btn');
		this.signout_btn = document.querySelector('.signout-btn');
		this.input = this.root.querySelectorAll('.input');
		this.input_body = this.root.querySelectorAll('.input__body');
		this.hidden_login = document.querySelector('input[name="user_auth_cond"]');
		this.next = [];
		this.toast = document.querySelector('.sign-modal');
		this.dir = location.pathname
			.split('/')
			.filter(Boolean)
			.pop();

		this.addListeners();
	}

	/**
	 * イベント登録
	 */
	addListeners() {
		$(document).on("click", '.pm-item__product__fullpdf', this.modalOpen.bind(this));

		// モーダル開くボタン
		if (this.open_btn) {
			for (let i = 0, l = this.open_btn.length; i < l; i++) {
				this.open_btn[i].addEventListener('click', this.modalOpen.bind(this), false);
			}
		}

		// モーダル閉じるボタン
		for (let i = 0, l = this.close_btn.length; i < l; i++) {
			this.close_btn[i].addEventListener('click', this.modalClose.bind(this), false);
		}

		// モーダルコンテンツの閉じるイベント伝播禁止
		for (let i = 0, l = this.container.length; i < l; i++) {
			this.container[i].addEventListener('click', e => {
				e.stopPropagation();
			});
		}

		// モーダル切り替え
		for (let i = 0, l = this.move_btn.length; i < l; i++) {
			this.move_btn[i].addEventListener('click', this.modalMove.bind(this), false);
		}

		// サインアウトボタン
		if (this.signout_btn) this.signout_btn.addEventListener('click', this.signout.bind(this), false);

		// submitボタン
		for (let i = 0, l = this.submit_btn.length; i < l; i++) {
			this.submit_btn[i].addEventListener('click', this.submitOnClick.bind(this), false);
		}

		// inputイベント追加
		for (let i = 0, l = this.input.length; i < l; i++) {
			this.input[i].addEventListener('click', this.inputOnFocus.bind(this), false);
		}

		// input_bodyイベント追加
		for (let i = 0, l = this.input_body.length; i < l; i++) {
			let current = this.input_body[i];

			current.value = '';
			current.addEventListener('focus', this.inputOnFocus.bind(this), false);
			current.addEventListener('change', this.inputOnChange.bind(this), false);
			current.addEventListener('blur', this.inputOnBlur, false);
		}

		// サインイン/アウト確認モーダル
		this.toast.addEventListener('click', this.toastHide.bind(this), false);
		$(window).on('resize', $.proxy(this.onModalResize, this));
	}

	/**
	 * モーダル開く
	 */
	modalOpen(e) {
		e.preventDefault();
		// return;

		if (e.currentTarget.classList.contains('no-event')) {
			// e.preventDefault();
			return;
		}

		const href = e.currentTarget.href;
		const target = e.currentTarget.getAttribute('target');

		this.next = [href, target];

		this.root.querySelector('.degradation-area').classList.remove('degradation-area--show');

		// TEST METHOD
		if (e.currentTarget.classList.contains('modal-open--method')) {
			e.preventDefault();
			this.root.querySelector('.degradation-area').classList.add('degradation-area--show');
			/* if (e.currentTarget.classList.contains('modal-open--degradation')) {
				this.root.querySelector('.degradation-area').classList.add('degradation-area--show');
			} */

			tm.set(this.root, { css: { display: 'block', opacity: 0 } });
			this.method.classList.add('modal-container--show');

			tm.to(this.root, 1, {
				css: { opacity: 1 }
			});
			if($(this.method).height()>$(window).height()){
				if (mq.getLayout() === 'sp') {
					$('body,html').animate({ scrollTop: 0 }, 500);
				}
			}
			this.onModalResize();
		} else {
			// ログイン確認
			loginCheck().then(result => {
				const login = result.data.flg;

				// ログイン済
				if (login) {
					const g_header = document.querySelector('.global-header');
					g_header.parentNode.removeChild(g_header);
					document.body.insertAdjacentHTML('afterbegin', result.data.header_html);

					this.hidden_login.value = '1';

					this.headerChange();
					// this.onNext();
				} else {
					// 未ログイン
					tm.set(this.root, {
						css: { display: 'block', opacity: 0 }
					});
					this.portal.classList.add('modal-container--show');

					this.hidden_login.value = '0';

					tm.to(this.root, 1, {
						css: { opacity: 1 }
					});

					return false;
				}
			});
		}
	}

	/**
	 * モーダル閉じる
	 */
	modalClose(e) {
		if (e) e.preventDefault();

		tm.to(this.root, 1, {
			css: { opacity: 0 },
			onComplete: () => {
				tm.set(this.root, { clearProps: 'all' });
				tm.set(this.container, { clearProps: 'all' });
				for (let i = 0, l = this.container.length; i < l; i++) {
					this.container[i].classList.remove('modal-container--show');
				}
				this.root.querySelector('.modal-form--forgot').classList.remove('modal-form--forgot--success');
				this.root.querySelector('.forgot-email').value = '';
			}
		});
	}

	/**
	 * モーダル切り替え
	 */
	modalMove(e) {
		const _this = e.currentTarget;

		if (_this.classList.contains('modal-move--signin')) {
			tm.to(this.portal, 0.4, {
				css: { opacity: 0 },
				onComplete: () => {
					this.portal.classList.remove('modal-container--show');
					this.signin.classList.add('modal-container--show');

					tm.set(this.signin, { css: { opacity: 0 } });
					tm.to(this.signin, 0.4, {
						css: { opacity: 1 }
					});
				}
			});
		} else {
			tm.to(this.signin, 0.4, {
				css: { opacity: 0 },
				onComplete: () => {
					this.signin.classList.remove('modal-container--show');
					this.forgot.classList.add('modal-container--show');

					tm.set(this.forgot, { css: { opacity: 0 } });
					tm.to(this.forgot, 0.4, {
						css: { opacity: 1 }
					});
				}
			});
		}
	}

	/**
	 * サインアウトボタンクリック
	 */
	signout() {
		logout().then(result => {
			const g_header = document.querySelector('.global-header');
			g_header.parentNode.removeChild(g_header);
			document.body.insertAdjacentHTML('afterbegin', result.data.header_html);

			this.hidden_login.value = '0';

			this.headerChange();
		});
	}

	/**
	 * 送信ボタンクリック
	 * @param {*} e
	 */
	submitOnClick(e) {
		const _this = e.currentTarget;

		if (_this.classList.contains('modal-btn--signin')) {
			let email = this.root.querySelector('.signin-email').value;
			let pass = this.root.querySelector('.signin-pass').value;
			let keep = this.root.querySelector('.keep-check').checked;
			if (email && pass) {
				const msg = document.querySelector('.login-err-message');
				const errs = msg.querySelectorAll('span');

				for (let i = 0, l = errs.length; i < l; i++) {
					errs[i].style.display = 'none';
				}

				loginAuth({ id: email, pass: pass, keep: keep }).then(result => {
					if (result.data.flg) {
						const g_header = document.querySelector('.global-header');
						g_header.parentNode.removeChild(g_header);
						document.body.insertAdjacentHTML('afterbegin', result.data.header_html);
						this.hidden_login.value = '1';

						if (this.dir === 'register') location.href = '../profile/';

						// this.onNext();
						this.headerChange();
					} else {
						const err = result.messages;

						this.hidden_login.value = '0';

						if (err.no_such_user) msg.querySelector('.no_such_user').style.display = 'block';
						if (err.empty_password) msg.querySelector('.empty_password').style.display = 'block';
						if (err.wrong_password) msg.querySelector('.wrong_password').style.display = 'block';
						if (err.not_approval_user) msg.querySelector('.not_approval_user').style.display = 'block';
						if (err.other_errors) msg.querySelector('.other_errors').style.display = 'block';
					}
				});
			}
		} else {
			const form_forgot = this.root.querySelector('.modal-form--forgot');
			let email = this.root.querySelector('.forgot-email').value;

			if (email) {
				loginForgot({ id: email }).then(result => {
					if (result.data.flg) {
						form_forgot.classList.add('modal-form--forgot--success');
					}
				});
			}
		}
	}

	/**
	 * ログイン後のページ
	 */
	onNext() {
		this.modalClose();

		// if (this.next[1] === '_blank') {
		// 	window.open(this.next[0]);
		// }
		// else {
		// 	location.href = this.next[0];
		// }
	}

	/**
	 * ヘッダ差し替え後の処理
	 */
	headerChange() {
		this.open_btn = document.querySelectorAll('.modal-open');
		this.signout_btn = document.querySelector('.signout-btn');

		this.modalClose();

		// モーダル開くボタン
		if (this.open_btn) {
			for (let i = 0, l = this.open_btn.length; i < l; i++) {
				this.open_btn[i].addEventListener('click', this.modalOpen.bind(this), false);
			}
		}
		// サインアウトボタン
		if (this.signout_btn) this.signout_btn.addEventListener('click', this.signout.bind(this), false);

		this.toast.classList.add('sign-modal--show');
		if (this.hidden_login.value === '0') {
			this.toast.classList.add('sign-modal--show--signout');
		} else {
			this.toast.classList.add('sign-modal--show--signin');
		}
		clearTimeout(this.toast_timer);
		this.toast_timer = setTimeout(this.toastHide.bind(this), 2500);

		trigger(window, 'headerChange', {
			signin: this.hidden_login.value
		});
	}

	/**
	 * トーストメッセージ非表示
	 */
	toastHide() {
		tm.killTweensOf(this.toast);
		tm.to(this.toast, 0.2, {
			css: { opacity: 0 },
			ease: Power1.easeOut,
			onComplete: function() {
				this.target.classList.remove(
					'sign-modal--show',
					'sign-modal--show--signin',
					'sign-modal--show--signout'
				);
				tm.set(this.target, { clearProps: 'opacity' });
			}
		});
	}

	/**
	 * フォーカス処理
	 */
	inputOnFocus(e) {
		const _this = e.type === 'focus' ? e.currentTarget.parentNode : e.currentTarget;
		const body = e.type === 'focus' ? _this : _this.querySelector('.input__body');

		_this.classList.add('input--focus');
		body.focus();
	}

	/**
	 * 入力内容変更
	 */
	inputOnChange(e) {
		const _this = e.currentTarget;
		const val = _this.value;

		if (val) {
			_this.parentNode.classList.add('input--focus');
		}
	}

	/**
	 * ブラー処理
	 */
	inputOnBlur() {
		const input = this.parentNode;
		const val = this.value;

		if (val) return;

		input.classList.remove('input--focus');
	}

	onModalResize(){
		$(this.method).css({'height':''});
		if($(this.method).height()>$(window).height()){
			// $(this.method).css({'overflow-y':'scroll','height':$(window).height()})
			if (mq.getLayout() === 'sp') {
				if ($(this.method).height() > $('body').height()) {
					$(this.method).css({ 'overflow-y': 'scroll', 'height': $('body').height() - 70 });
				} else {
					$(this.method).css({'overflow':'','height':''});
				}
				
				// $('body,html').animate({ scrollTop: 0 }, 500);
			} else {
				$(this.method).css({'overflow-y':'scroll','height':$(window).height()})
			}
		}else{
			$(this.method).css({'overflow':'','height':''});
		}
	}
}



// WEBPACK FOOTER //
// ./src/js/module/Modal.js